import { VyTabs } from '../../../../../components/new-design/navigation';
import { ContractPageData } from '@vy/api-definition';
import type { CustomFieldDefinition, CustomFieldValueWithDefinition } from '@vy/custom-fields-types';
import { useContractBillingSectionTabs } from '../hooks/use-contract-billing-section-tabs';
import { VyPaper } from '../../../../../components/new-design/data-display/VyPaper/VyPaper';

type ContractBillingScheduleSectionProps = {
  contractPageData: ContractPageData;
  customFieldsWithDefinitions: CustomFieldValueWithDefinition[] | undefined;
  customFieldDefinitions: CustomFieldDefinition[] | undefined;
  startDate: Date;
  endDate?: Date;
};

export const ContractBillingScheduleSection = ({
  contractPageData,
  customFieldsWithDefinitions,
  customFieldDefinitions,
  startDate,
  endDate,
}: ContractBillingScheduleSectionProps) => {
  const { tabs, phaseDialog } = useContractBillingSectionTabs({
    startDate,
    endDate,
    contractPageData,
    customFieldsWithDefinitions,
    customFieldDefinitions,
  });

  return (
    <>
      <VyPaper sx={{ flexGrow: 1, minWidth: 0, overflowX: 'auto' }}>
        <VyTabs tabs={tabs} />
      </VyPaper>
      {phaseDialog}
    </>
  );
};
